import { extname } from 'path';

import { VideoFragment } from './../apollo/fragments/types/VideoFragment';

export function makeDownloadFromVideo(video?: VideoFragment): {
  url: string;
  name: string;
} | undefined {
  if (!video) {
    return;
  }
  const urlString = video.downloadUrl;
  if (!urlString) {
    return;
  }

  const realext = extname(new URL(urlString).pathname);
  return {
    url: urlString,
    name: video.name.substring(0, video.name.length - extname(video.name).length) + realext,
  };
};
